import React from 'react';
interface PageTitleProps {
  children: React.ReactNode;
}
export function PageTitle({
  children
}: PageTitleProps) {
  return <h1 className="text-fluid-2xl md:text-[clamp(2.369rem,4vw,3.157rem)] font-bold mb-8 animate-fadeIn tracking-tight text-[#111111]" data-id="element-128">
      {children}
    </h1>;
}